import { all, fork } from "redux-saga/effects";

import * as authSaga from "./authSaga";
import * as companySaga from './companySaga';
import * as serviceCitySaga from "./ServiceCitySaga";
import * as chooseYourService from "./ChooseYourServiceSaga";

import * as Logout from "./LogoutSaga"
import * as AdminUser from "./AdminUserSaga"

export default function* rootSaga() {
    yield all([
    ...Object.values(authSaga),
    ...Object.values(companySaga),
    ...Object.values(serviceCitySaga),
    ...Object.values(chooseYourService),
    ...Object.values(Logout),
    ...Object.values(AdminUser),
   ].map(fork));
  }
